import { z } from 'zod';
import { AiUseCaseSchema as AiUseCaseValues } from './ai-use-case';
export const AiUseCaseSchema = z.enum(AiUseCaseValues);
export const AiUseCase = AiUseCaseSchema.enum;
export const AiWorkflowFileSchema = z.object({
    name: z.string(),
    source: z.object({
        sourceType: z.literal('BYTE_CONTENT'),
        byteContent: z.object({
            mediaType: z.string(),
            data: z.string(),
        }),
    }),
});
const AiWorkflowSessionStateShape = {
    files: AiWorkflowFileSchema.array(),
};
export const AiWorkflowSessionStateSchema = z.object(AiWorkflowSessionStateShape);
const AiWorkflowInvocationShape = {
    agentUseCase: AiUseCaseSchema,
    inputText: z.string(),
    sessionState: AiWorkflowSessionStateSchema.optional(),
};
export const AiWorkflowInvocationSchema = z.object(AiWorkflowInvocationShape);
export const AiWorkflowResponseSchema = z.object({
    response: z.string(),
});
const AiWorkflowRequestShape = {
    prompt: z.string(),
    files: AiWorkflowFileSchema.array().optional(),
};
export const AiWorkflowRequestSchema = z.object(AiWorkflowRequestShape);
export const AsyncInvokeAgentStatusSchema = z.enum(['pending', 'failed']);
export const AsyncInvokeAgentLocalizedTextSchema = z.object({
    de: z.string(),
    en: z.string(),
});
export const AsyncInvokeAgentProgressStepStatusSchema = z.enum([
    'pending',
    'running',
    'retrying',
    'completed',
    'not_found',
    'failed',
    'skipped',
]);
const AsyncInvokeAgentProgressStepShape = {
    id: z.string(),
    label: AsyncInvokeAgentLocalizedTextSchema,
    description: AsyncInvokeAgentLocalizedTextSchema,
    status: AsyncInvokeAgentProgressStepStatusSchema,
    completed_units: z.number().optional(),
    total_units: z.number().optional(),
    unit: z.string().optional(),
};
export const AsyncInvokeAgentProgressStepSchema = z.object(AsyncInvokeAgentProgressStepShape);
export const AsyncInvokeAgentPartialResultSchema = z.object({
    step_id: z.string(),
    revision: z.number(),
    value: z.unknown(),
});
const AsyncInvokeAgentWarningShape = {
    warning_type: z.string(),
    message: AsyncInvokeAgentLocalizedTextSchema,
};
export const AsyncInvokeAgentWarningSchema = z.object(AsyncInvokeAgentWarningShape);
const AsyncInvokeAgentProgressSnapshotShape = {
    version: z.literal(1),
    sequence: z.number(),
    steps: AsyncInvokeAgentProgressStepSchema.array(),
    partial_results: AsyncInvokeAgentPartialResultSchema.array(),
    warnings: AsyncInvokeAgentWarningSchema.array(),
};
export const AsyncInvokeAgentProgressSnapshotSchema = z.object(AsyncInvokeAgentProgressSnapshotShape);
const AsyncInvokeAgentPendingShape = {
    invocationId: z.string(),
    status: z.literal('pending'),
    expiresAt: z.string(),
    pollUrl: z.string().optional(),
    progress: AsyncInvokeAgentProgressSnapshotSchema.optional(),
};
const AsyncInvokeAgentPendingSchema = z.object(AsyncInvokeAgentPendingShape);
const AsyncInvokeAgentFailedShape = {
    ...AsyncInvokeAgentPendingShape,
    status: z.literal('failed'),
    error: z.string(),
};
const AsyncInvokeAgentFailedSchema = z.object(AsyncInvokeAgentFailedShape);
export const AsyncInvokeAgentLifecycleSchema = z.discriminatedUnion('status', [AsyncInvokeAgentPendingSchema, AsyncInvokeAgentFailedSchema]);
